module.exports = __webpack_public_path__ + "static/media/google.298bf198.png";